import axios from "axios";
import { loginRequest, msalInstance } from "../authConfig";
import { setNavNumber, DEFAULT_NAV_NUMBER } from "../config/config";

const baseUrl = process.env.REACT_APP_DATA360_BACKEND_URL;

export const Data360AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

Data360AxiosInstance.interceptors.request.use(async (config) => {
  if (!msalInstance) return config;
  try {
    await msalInstance.initialize();
    const account =
      msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
    if (account) {
      try {
        const tokenResponse = await msalInstance.acquireTokenSilent({
          scopes: loginRequest.scopes,
          account,
        });
        config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
      } catch {
        await msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account,
        });
      }
    }
  } catch (e) {
    console.warn(
      "MSAL not ready for Data360, sending request without auth token:",
      e.message,
    );
  }
  return config;
});

Data360AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Data360 API Error:", {
      message: error.message,
      status: error?.response?.status,
      baseURL: error.config?.baseURL,
    });
    return Promise.reject(error);
  },
);

export async function fetchLatestNav() {
  const response = await Data360AxiosInstance.get("sna-soo/latest-nav");
  return response?.data?.data?.total_nav;
}

export async function initNavNumber() {
  try {
    const liveNav = await fetchLatestNav();
    if (liveNav && typeof liveNav === "number" && liveNav > 0) {
      setNavNumber(liveNav);
      console.log(`NAV_NUMBER updated from Data360: ${liveNav}`);
    } else {
      console.warn("Data360 returned invalid NAV, using default:", DEFAULT_NAV_NUMBER);
    }
  } catch (error) {
    console.warn("Failed to fetch NAV from Data360, using default:", error.message);
  }
}

/**
 * Live LMV / SMV / net / gross exposure per strategy type from data360's Risk
 * Limits framework (POST /risk-limits/utilization). Rows are rolled up the same
 * way as the Risk Limits page (e.g. EDFI = YTM + Expected Call + Redemption).
 */
export async function fetchRiskLimitsExposure(date, { signal } = {}) {
  const response = await Data360AxiosInstance.post(
    "risk-limits/utilization",
    { start_date: date, end_date: date },
    signal ? { signal } : undefined,
  );
  return response?.data?.data || [];
}
